import { render, staticRenderFns } from "./PaymentChannelDialog.vue?vue&type=template&id=15ad1016&scoped=true"
import script from "./PaymentChannelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentChannelDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaymentChannelDialog.vue?vue&type=style&index=0&id=15ad1016&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad1016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ad1016')) {
      api.createRecord('15ad1016', component.options)
    } else {
      api.reload('15ad1016', component.options)
    }
    module.hot.accept("./PaymentChannelDialog.vue?vue&type=template&id=15ad1016&scoped=true", function () {
      api.rerender('15ad1016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/finance/components/PaymentChannelDialog.vue"
export default component.exports